import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { msUntilHalloweenNightEnds } from "@/config/halloweenNightWheel";
import { creepyStage } from "@/lib/creepyStage";

function fmt(ms: number) {
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
}

/** Halloween theme Oct 1 – Nov 1 06:00, escalating by stage; full creepy look while the Halloween Night wheel is open; switches off at 06:00 by itself. */
export function CreepyOverlay() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [now, setNow] = useState(() => new Date());
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(id); }, []);
  const skip = /print|overlay/.test(pathname);
  const stage = skip ? 0 : creepyStage(now);
  const on = stage === 5;
  useEffect(() => {
    const el = document.documentElement;
    if (on) el.setAttribute("data-creepy", ""); else el.removeAttribute("data-creepy");
    if (stage > 0 && stage < 5) el.setAttribute("data-creepy-stage", String(stage)); else el.removeAttribute("data-creepy-stage");
    return () => { el.removeAttribute("data-creepy"); el.removeAttribute("data-creepy-stage"); };
  }, [on, stage]);
  if (stage === 0) return null;
  if (!on) return (
    <div className="creepy-layer" data-stage={stage} aria-hidden="true">
      <div className="creepy-vignette" />
      <div className="creepy-fog" />
      {stage >= 2 && <span className="creepy-critter creepy-bat">🦇</span>}
      {stage >= 3 && <span className="creepy-critter creepy-spider">🕷️</span>}
    </div>
  );
  return (
    <>
      <div className="creepy-layer" aria-hidden="true">
        <div className="creepy-vignette" />
        <div className="creepy-fog" />
        <span className="creepy-critter creepy-bat">🦇</span>
        <span className="creepy-critter creepy-spider">🕷️</span>
      </div>
      <div className="creepy-banner" role="status">
        <span>🕯️ {t("creepyNight.banner")} · {t("creepyNight.left", { time: fmt(msUntilHalloweenNightEnds(now)) })}</span>
        {pathname !== "/halloween-night" && <Link to="/halloween-night" className="underline font-semibold">{t("creepyNight.cta")}</Link>}
      </div>
    </>
  );
}
